import React from 'react';
import { Image, Text } from "react-native";
import { SafeAreaView } from "react-native-safe-area-context";

import splash from '../../../assets/splash-cathecism-loading.png';

const Loading = () => {
    return (
        <SafeAreaView style={{
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center'
        }}>
            <Image source={splash} resizeMode="contain" style={{
                width: "100%",
                height: "100%"
            }} />
        </SafeAreaView>
    );
};

export default Loading;